(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
   function getProductJsonLdObjectAndSetResult(el) {

    const aria = el?.getAttribute('aria-label');

    const yotpoRatings = aria.split(' ')[1].split(' ')[0];
    const yotpoNoReviews = aria.split('from ')[1].split(' reviews')[0];

    /* Google flags 0 reviews as invalid */
    if(Number(yotpoNoReviews) === 0) {
      return;
    }

    const scripts = document.querySelectorAll('script[type="application/ld+json"]');

    let result = null;

    for (const script of scripts) {
      let data;

      try {
        data = JSON.parse(script.textContent);
      } catch {
        continue;
      }

      // Case 1: single object
      if (data && data['@type'] === 'Product') {
        result = { script, root: data, product: data };
      }

      // Case 2: array of objects
      if (Array.isArray(data)) {
        const product = data.find(obj => obj && obj['@type'] === 'Product');
        if (product) {
          result = { script, root: data, product };
        }
      }

      // Case 3: @graph
      if (data && Array.isArray(data['@graph'])) {
        const product = data['@graph'].find(obj => obj && obj['@type'] === 'Product');
        if (product) {
          result = { script, root: data, product };
        }
      }
    }

    if (result) {
      result.product.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: yotpoRatings,
        ratingCount: yotpoNoReviews,
        reviewCount: yotpoNoReviews
      };

      result.script.textContent = JSON.stringify(result.root);
    }
  }

  const widget = document.querySelector('.yotpo-sr-bottom-line-summary');

  if (widget) {
    console.log('Yotpo already loaded');
    getProductJsonLdObjectAndSetResult(widget);
  } else {
    const observer = new MutationObserver((mutations, obs) => {
      const widget = document.querySelector('.yotpo-sr-bottom-line-summary');

      if (widget) {
        console.log('Yotpo loaded');
        getProductJsonLdObjectAndSetResult(widget);
        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  } catch(e) { console.error(e); }
})();
})();
